var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSustainability = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Renewable-Energy-Wind-Turbine--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Renewable Energy Wind Turbine Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.83 10.63a0.51 0.51 0 0 0 0.62 0.06 3.42 3.42 0 0 1 1.94 -0.59 3.34 3.34 0 0 1 1.15 0.19 0.49 0.49 0 0 0 0.44 -0.06 0.47 0.47 0 0 0 0.22 -0.38l0.62 -8A1.65 1.65 0 0 0 13.31 0a1.67 1.67 0 0 0 -1.68 1.08L8.82 8.85a1 1 0 0 0 0.25 1.07Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.84 18.36 0.24 -1a0.5 0.5 0 0 0 -0.26 -0.57 3.49 3.49 0 0 1 -1.49 -1.39 3.42 3.42 0 0 1 -0.4 -1.09 0.5 0.5 0 0 0 -0.27 -0.31 0.49 0.49 0 0 0 -0.44 0L0.94 17.44a1.65 1.65 0 0 0 1 3.11L10 19.11a1 1 0 0 0 0.84 -0.75Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.62 19.23 -5.3 -6.3a1 1 0 0 0 -1.05 -0.32l-1 0.3a0.5 0.5 0 0 0 -0.36 0.51 3.51 3.51 0 0 1 -0.46 2 3.63 3.63 0 0 1 -0.74 0.9 0.48 0.48 0 0 0 -0.17 0.4 0.49 0.49 0 0 0 0.21 0.38l6.67 4.57a1.65 1.65 0 0 0 2.19 -2.42Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05 14.63a1 1 0 0 0 1 -1 8.38 8.38 0 0 1 3.59 -6.86 1 1 0 0 0 0.26 -1.39 1 1 0 0 0 -1.4 -0.25 10.37 10.37 0 0 0 -4.45 8.5 1 1 0 0 0 1 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.33 21a8.38 8.38 0 0 1 -7.54 0.17A1 1 0 1 0 7.93 23a10.4 10.4 0 0 0 9.35 -0.21 1 1 0 1 0 -1 -1.76Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.08 6.73a8.33 8.33 0 0 1 3.6 5.95 1 1 0 0 0 2 -0.22 10.36 10.36 0 0 0 -4.48 -7.39 1 1 0 0 0 -1.12 1.66Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.39 11.61a2 2 0 1 0 2 2 2 2 0 0 0 -2 -2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSustainability);
export default ForwardRef;